import styled, { css } from 'styled-components'
import { ChevronCircleIcon } from '@sainsburys-tech/bolt-icons'
import { Button } from '@sainsburys-tech/bolt'
import { createCSSObject, remCalculator } from '../../../helpers/theming/utilities'

export const Container = styled.div`
  background-color: ${(props) =>
    props.theme.channel === 'nectar' ? props.theme.color.monochrome.white : props.theme.color.monochrome.lighter};
  border-radius: ${(props) => props.theme.size.border.radius.base};
  position: relative;
  text-align: center;
`

export const TopContainer = styled.div`
  padding: 20px;
  width: 100%;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    width: 70%;
    margin: auto;
  }
`

export const Heading = styled.h3`
  margin-top: 30px;
`

export const Filters = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: wrap;
  margin: auto;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    max-width: 95%;
  }
`

export const Filter = styled.button`
  ${(props) =>
    css`
      background: ${props.theme.color.monochrome.white};
      border: ${props.theme.size.border.width.sm} solid ${props.theme.color.monochrome.light};
      border-radius: ${props.theme.size.border.radius.base};
      justify-content: ${props.hasLabel ? 'flex-end' : 'center'};
      font-size: ${props.theme.font.size.caption};
    `}
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  width: ${remCalculator(128)};
  height: ${remCalculator(130)};
  margin: 5px;
  position: relative;
  padding: 13px 5px 0;

  picture {
    margin: auto;
  }

  img {
    margin-bottom: 5px;
  }

  ${(props) =>
    props.isActive &&
    css`
      border: ${props.theme.size.border.width.md} solid ${props.theme.color.semantic.success.base};
      font-weight: ${props.theme.font.weight.bold};
    `};

  ${(props) =>
    css`
      p {
        color: ${props.theme.color.palette['brand-3']};
        font-size: ${props.theme.font.size.caption};
        font-weight: ${props.theme.font.weight['semi-bold']};
        line-height: 1rem;
        padding: 0 ${props.theme.size.spacing.md};
      }

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        width: ${remCalculator(185)};
        height: ${remCalculator(185)};

        p {
          ${createCSSObject(props.theme.font.stack['label-1'])}
        }
    `};
`
export const IconWrapper = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  width: 35px;
  height: 35px;
  background: ${(props) => props.theme.color.semantic.success.base};
  color: ${(props) => props.theme.color.monochrome.white};
`

export const Chevron = styled(ChevronCircleIcon)`
  margin-left: 3px;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  max-width: ${remCalculator(260)};
  margin: auto;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    justify-content: space-between;
    width: ${remCalculator(775)};
    max-width: 95%;
  }
`

export const NavButton = styled(Button)`
  color: ${(props) => props.theme.color.palette['brand-3']};
  margin: 20px 0;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    width: auto;
    margin: 24px 0;

    ${(props) =>
      props.resultsMargin &&
      css`
        margin-${props.resultsMargin}: ${props.currentCount === 0 ? '21%' : '39.09%'};
      `};
  }
`

export const BackButton = styled(NavButton)`
  @media screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].sm}) {
    margin-right: auto;
  }
`

export const ResultsButton = styled(NavButton)`
  ${(props) =>
    props.kind === 'primary' &&
    css`
      color: ${props.theme.color.monochrome.white};
      margin-right: ${props.currentCount === 0 ? '21%' : '39.5%'};
    `};

  @media screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].sm}) {
    order: 3;
    flex: 1 0 100%;
    margin: 10px 0 30px;
  }
`

export const ErrorContainer = styled.div`
  flex-direction: column;
  padding-bottom: 12px;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    padding-bottom: 0;
  }
`

export const TryAgainLink = styled(Button)`
  display: flex;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].sm}) {
    width: auto;
    display: inline-block;
  }

  && {
    color: ${(props) => props.theme.color.palette['blue-60']};
  }
`
